export default __webpack_public_path__ + "static/core-af9378e2baadf00ee8c75118630c5c6f.png";